import React from 'react';
export function BubbleLegend() {
  return;
}